import { IPlayerState } from '../../../State/Player/IPlayerState';
import IPlayerData from '../../IPlayerData';
import { restoreBoolean } from '../../ParseHelper';
import PlayerProperty from '../PlayerProperty';

export default class FTUE extends PlayerProperty<
    boolean,
    {
        FTUE: number;
    }
> {
    public readonly defaultValue: boolean = false;

    public restore(playerEndpointData: IPlayerData): boolean {
        const value = restoreBoolean(playerEndpointData.FTUE);

        if (value !== null) return value;

        // If FTUE is not set then use "level_star".
        // If no "level_star" is present then FTUE is TRUE, otherwise FALSE.
        return !playerEndpointData.level_star;
    }

    public save(playerStateData: IPlayerState) {
        return { FTUE: playerStateData.FTUE ? 0 : 1 };
    }

    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        return playerStateData.FTUE !== this.restore(playerEndpointData);
    }
}
